import { useContext, useMemo } from "react"

import { FlowContext } from "#/shared/context"
import { BridgeAssetFormValue } from "#/shared/types"

import { BaseModalProps } from "../BaseModal"

import BridgeAssetStepperModal from "./BridgeAssetStepperModal"

export default function BridgeNewAssetModal({ ...props }: BaseModalProps) {
  const { isBitcoinFlow } = useContext(FlowContext)

  const contextValue: BridgeAssetFormValue = useMemo(
    () => ({
      amount: undefined,
      token: "BTC",
      shouldUseAnotherWallet: !isBitcoinFlow,
    }),
    [isBitcoinFlow],
  )

  return <BridgeAssetStepperModal {...props} contextValue={contextValue} />
}
